import axios from "axios";

export const LOGIN_URL = "token";
export const REGISTER_URL = "create-account";
export const SYSTEM_USER_REGISTER_URL = "create-system-user";
export const REQUEST_PASSWORD_URL = "reset-password";

export const ME_URL = "account";

export function login(email, password) {
  return axios.post(process.env.REACT_APP_API_BASE_URL + LOGIN_URL, {
    userName: email,
    password: password,
  });
}

export function registerSystemUser(fullname, username, password) {
  let nameSplit = fullname.split(" ");

  let data = {
    user: {
      firstName: nameSplit[0],
      lastName: nameSplit[1] != undefined ? nameSplit[1] : "",
      email: username,
      userName: username,
      password: password,
    },
  };

  return axios.post(
    process.env.REACT_APP_API_BASE_URL + SYSTEM_USER_REGISTER_URL,
    data
  );
}
export function register(
  email,
  fullname,
  username,
  password,
  taxId,
  currencyCode
) {
  let nameSplit = fullname.split(" ");

  let data = {
    user: {
      firstName: nameSplit[0],
      lastName: nameSplit[1] != undefined ? nameSplit[1] : "",
      email: username,
      userName: username,
      password: password,
    },
    accountName: taxId,
    accountTaxId: taxId,
    currencyCode: currencyCode,
  };

  return axios.post(process.env.REACT_APP_API_BASE_URL + REGISTER_URL, data);
}

export function requestPassword(email) {
  return axios.post(process.env.REACT_APP_API_BASE_URL + REQUEST_PASSWORD_URL, {
    userName: email,
  });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(process.env.REACT_APP_API_BASE_URL + ME_URL);
}
